import { $rtkApi } from './rtkApi';
import { PaymentStatus } from 'shared';

export interface StripeId {
    paymentId: string;
}

interface StripeStatus {
    paymentStatus : PaymentStatus;
}

const stripeStatusApi = $rtkApi.injectEndpoints({
    endpoints: (build) => ({
        getStatus: build.mutation<StripeStatus, StripeId>({
            query: (arg: StripeId) => {
                return {
                    url: `/api/callback/stripe?payment_id=${arg.paymentId}`,
                    method: "GET",
                };
            },
        }),
    }),
    overrideExisting: false,
});


export const useStripeStatus = stripeStatusApi.useGetStatusMutation;